acadmy-content
<template>
  <Sidebar v-if="store.state.user_data" />
  <Content class="acadmy-content" v-loading="loading || all_Loading || loading_table">
    <header class="page-header-acdemy">
      <h3>{{ $ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ' }}</h3>
      <div class="right-btn-block">
        <el-select
          v-model="selectedPage"
          class="page-filter-select"
          @change="onPageChange"
        >
          <el-option label="All Pages" value="0" />
          <el-option
            v-for="page in pageList"
            :key="page.id"
            :label="page.title"
            :value="page.id"
          />
        </el-select>
        <el-button v-if="academies.length > 0 || selectedPage !== '0'" type="primary" @click="acadmyEdit.open(null, pageList)">
          <svg-icon name="plus" /> New Article</el-button
        >
        <el-button @click="previewAcademy()">Preview</el-button>
      </div>
    </header>
    <div class="table-top-header" :style="topHeaderStyle">
      <div class="left-header">
        <h1 :style="`color:${designForm.textColor}`">{{ designForm.title }}</h1>
        <div class="subtitle" :style="`color:${designForm.subtextColor}`">{{ designForm.subtext }}</div>
      </div>
      <el-button @click="openDesignDialog"><svg-icon name="pen" /></el-button>
    </div>

    <Scrollbar class="academy-table-scroll" :show_bar="true">
      <table class="academy-table ui-table" :class="{ 'is-loading': loading || loading_table }">
        <thead class="thead">
          <tr>
            <th v-if="canReorder" class="col-drag"></th>
            <th class="col-article"><span>Article</span></th>
            <th class="col-status"><span>Status</span></th>
            <TableTh
              :name="'updated_at'"
              :title="'Last Update'"
              :sort_value="sort"
              @sort="sortFun"
              :content="'Last Update'"
            />
            <TableTh
              :name="'created_at'"
              :title="'Date Created'"
              :sort_value="sort"
              @sort="sortFun"
              :content="'Date Created'"
            />
            <TableTh :name="'page'" :title="'Page'" :sort_value="sort" @sort="sortFun" :content="'Page'" />
            <th class="col-actions"><span>Actions</span></th>
          </tr>
        </thead>

        <DropList
          :items="academies"
          tag="tbody"
          class="tbody"
          :no-animations="true"
          @reorder="onReorder"
        >
          <template #item="{ item }">
            <Drag :key="item.id" :data="item" tag="tr" handle=".drag-handle">
              <!-- Drag handle -->
              <td v-if="canReorder" class="col-drag">
                <span class="drag-handle"><svg-icon name="move" /></span>
              </td>

              <!-- Article Column -->
              <td class="col-article">
                <div class="article-cell">
                  <img :src="item.cover_image_url || NoImage" alt="article cover" class="article-img" />
                  <span class="article-title">{{ item.title }}</span>
                </div>
              </td>

              <!-- Status Column -->
              <td class="col-status">
                <div>{{ item.status_text }}</div>
                <div class="text-50" v-if="item.have_unpublished_draft || item.status === STATUS_CODE.Draft">
                  <span v-if="item.have_unpublished_draft && item.status !== STATUS_CODE.Draft">Change saved, </span>
                  <span class="pub-btn" @click="openConfirmDialog(DOTHING_CODE.Publish, item)">
                    {{
                      item.status === STATUS_CODE.Active || item.status === STATUS_CODE.Hidden ? 'Publish now' : 'Publish'
                    }}
                  </span>
                </div>
              </td>

              <!-- Last Update Column -->
              <td class="col-last-update">
                <div>{{ item.updated_by_user?.name || 'Motom' }}</div>
                <span class="date-line">{{
                  formatDate(item.last_creator_academy_article_draft.updated_at, 'MMM DD, YYYY')
                }}</span>
                <span class="time-line">{{
                  formatDate(item.last_creator_academy_article_draft.updated_at, 'hh:mm A')
                }}</span>
              </td>

              <!-- Date Created Column -->
              <td class="col-date-created">
                <div>{{ item.created_by_user?.name || 'Motom' }}</div>
                <span class="date-line">{{ formatDate(item.created_at, 'MMM DD, YYYY') }}</span>
                <span class="time-line">{{ formatDate(item.created_at, 'hh:mm A') }}</span>
              </td>

              <!-- Page Column -->
              <td class="col-page">
                <AcadmyPickPage
                  :initValue="item.creator_academy_page_text"
                  :allPages="pageList"
                  :item="item"
                  :key="item.creator_academy_page_text"
                />
              </td>

              <!-- Actions Column -->
              <td class="col-actions">
                <div class="actions-cell">
                  <svg-icon
                    name="pen"
                    class="action-icon action-edit"
                    @click="acadmyEdit.open(item, pageList)"
                    title="Edit"
                  />
                  <svg-icon
                    v-if="item.status !== STATUS_CODE.Draft"
                    :name="item.status === STATUS_CODE.Hidden ? 'eye-hidden' : 'eye'"
                    class="action-icon action-preview"
                    @click="
                      openConfirmDialog(
                        item.status === STATUS_CODE.Hidden ? DOTHING_CODE.Unhide : DOTHING_CODE.Hide,
                        item
                      )
                    "
                    title="Preview"
                  />
                  <svg-icon
                    name="delete2"
                    class="action-icon action-delete"
                    @click="
                      openConfirmDialog(
                        item.status === STATUS_CODE.Draft ? DOTHING_CODE.DeleteDraft : DOTHING_CODE.DeleteActive,
                        item
                      )
                    "
                    title="Delete"
                  />
                </div>
              </td>
            </Drag>
          </template>

          <!-- Drag placeholder row -->
          <template #feedback>
            <tr class="drag-feedback-row">
              <td colspan="7"></td>
            </tr>
          </template>

          <!-- Empty state -->
          <template #empty>
            <tr>
              <td colspan="7">
                <div class="no-data">
                  <template v-if="selectedPage !== '0'">
                    <p>No articles found for this page.</p>
                  </template>
                  <template v-else>
                    <p>No article has been created yet.</p>
                    <el-button type="primary" @click="acadmyEdit.open(null, pageList)"
                      ><svg-icon name="plus" /> Create article</el-button
                    >
                  </template>
                </div>
              </td>
            </tr>
          </template>
        </DropList>
      </table>
    </Scrollbar>

    <CreateEditAcadmy ref="acadmyEdit" :pageList="pageList" @callPublish="callPublish" />
  </Content>

  <!-- Alert Dialog -->
  <el-dialog
    class="alert-handle-dialog"
    v-model="handleAllModel"
    :show-close="false"
    :show-header="false"
    width="350px"
    append-to-body
  >
    <h3>{{ alertContent.title }}</h3>
    <div>{{ alertContent.desc }}</div>
    <div class="btn-box">
      <el-button @click="closeHandleModel()" type="text">{{
        handle_doThing_type === 5 ? 'Discard' : 'Cancel'
      }}</el-button>
      <el-button type="primary" @click="handleAlertConfirm">{{
        handle_doThing_type === 5 ? 'Save and exit' : 'Confirm'
      }}</el-button>
    </div>
  </el-dialog>

  <DesignDialog
    :visible="designDialogVisible"
    :initial-form="designForm"
    @update:visible="designDialogVisible = $event"
    @publish="onDesignPublish"
  />

  <!-- no cover dialog -->
  <el-dialog v-model="noCoverPublishDialogVisible" width="400px" :show-close="false" :show-header="false" class="alert-handle-dialog" append-to-body>
 
    <h3>Unable to publish article</h3>
    <div>A cover image is required to publish your article. Please upload a cover image before publishing.</div>
    <div class="btn-box">
      <el-button type="primary" @click="noCoverPublishDialogVisible = false">Ok</el-button>
    </div>
  </el-dialog>
</template>

<script setup>
import emitter from '@/utils/EventBus';
import { ref, onMounted, onUnmounted, computed, getCurrentInstance, watch, h } from 'vue';
import { ElInput, ElButton, ElTable, ElTableColumn, ElDialog, ElMessage, ElButtonGroup, ElSelect, ElOption } from 'element-plus';
import { Drag, DropList } from 'vue-easy-dnd';
import 'vue-easy-dnd/dist/dnd.css';
import moment from 'moment';
import { useStore } from 'vuex';
import CreateEditAcadmy from '@/components/settings/Acadmy/CreateEditAcadmy.vue';
import AcadmyPickPage from '@/components/settings/Acadmy/AcadmyPickPage.vue';
import DesignDialog from '@/components/settings/Acadmy/DesignDialog.vue';
import Sidebar from '@/components/Sidebar.vue';
import Content from '@/components/ui/Content.vue';
import TableTh from '@/components/ui/TableTh.vue';
import Scrollbar from '@/components/ui/Scrollbar.vue';
import { useNotification } from '@/components/ui/notification';
import NoImage from '@/assets/images/no-image.png';
import { useAcadmyFunction } from '@/components/settings/Acadmy/AcadmyFunction.js';

const app = getCurrentInstance();
const ajax = app.appContext.config.globalProperties.$ajax;
const { $ProjectName } = app.appContext.config.globalProperties;
const store = useStore();
const { openNotBottom } = useNotification();
const { STATUS_CODE, DOTHING_CODE, handListData, goPreview } = useAcadmyFunction();

const acadmyEdit = ref(null);
const loading = ref(false);
const all_Loading = ref(false);
const loading_table = ref(false);

const designDialogVisible = ref(false);
const designForm = ref({
  title: $ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ',
  subtext: $ProjectName === 'cj' ? 'Manage your Creator Academy content here.' : 'Manage your Creator HQ content here.',
  backgroundType: 'color',
  color: '#F1F4F9',
  textColor: '#000000',
  subtextColor: '#000000',
  image: null,
  imageUrl: '',
});

const prevHeaderSaved = ref(null);
// headerSaved holds the persisted background (only updated on Publish)
const headerSaved = ref({
  backgroundType: 'color',
  color: '#F1F4F9',
  textColor: '#000000',
  subtextColor: '#000000',
  imageUrl: '',
});

const academies = ref([]);
const sort = ref({
  sort_key: '',
  sort_val: 'desc',
});
const pageList = ref([]);
const selectedPage = ref('0');

const canReorder = computed(() => !sort.value.sort_key && selectedPage.value !== '0');

// computed style for top header background (preview when dialog open, otherwise saved)
const topHeaderStyle = computed(() => {
  const src = designDialogVisible.value ? designForm.value : headerSaved.value;
  if (!src) return {};
  if (src.backgroundType === 'color') {
    return {
      backgroundColor: src.color,
      backgroundImage: 'none',
      backgroundSize: 'auto',
      backgroundPosition: 'center',
    };
  }
  if (src.backgroundType === 'image' && src.imageUrl) {
    return {
      backgroundImage: `url('${src.imageUrl}')`,
      backgroundSize: 'cover',
      backgroundPosition: 'center',
    };
  }
  return {};
});

// restore values if dialog closed without publish
watch(
  () => designDialogVisible.value,
  (visible) => {
    if (!visible) {
      // if there was a snapshot and headerSaved unchanged, user didn't publish
      if (prevHeaderSaved.value && JSON.stringify(prevHeaderSaved.value) === JSON.stringify(headerSaved.value)) {
        // restore displayed header and form to saved values
        designForm.value.backgroundType = headerSaved.value.backgroundType || 'color';
        designForm.value.color = headerSaved.value.color || '#F1F4F9';
        designForm.value.textColor = headerSaved.value.textColor || '#000000';
        designForm.value.subtextColor = headerSaved.value.subtextColor || '#000000';
        designForm.value.imageUrl = headerSaved.value.imageUrl || '';
      }
      prevHeaderSaved.value = null;
    }
  }
);

//-------------
// Alert Dialog State
//-------------
const handleAllModel = ref(false);
const handle_doThing_type = ref(1);
const handle_doThing_data = ref(null);
const alertCallback = ref(null);
const noCoverPublishDialogVisible = ref(false);
const alertContent = computed(() => {
  let title = '',
    desc = '';
  let data = handle_doThing_data.value || {};
  let statusText =
    data.status === STATUS_CODE.Hidden ? 'hidden' : data.status === STATUS_CODE.Active ? 'published' : 'draft';
  console.log('data', data);
  switch (handle_doThing_type.value) {
    case 1:
      title = 'Publish this article?';
      desc = `This article will be published on the ${$ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ'} immediately.`;
      break;
    case 2:
      title = 'Delete this draft?';
      desc = 'This article will be removed from your list. This action cannot be undone.';
      break;
    case 3:
      title = 'Hide this article?';
      desc = `This will hide the article on the ${$ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ'} immediately.`;
      break;
    case 4:
      title = `Delete this article?`;
      desc = `This article will be removed immediately. This action cannot be undone`;
      break;
    case 5:
      title = 'Exit without saving?';
      desc = 'Unsaved changes will be permanently deleted. This action cannot be undone.';
      break;
    case 6:
      if (data.status === STATUS_CODE.Hidden) {
        title = `Save changes to this ${statusText} article?`;
        desc = 'This is hidden article will save as a draft.';
      } else {
        title = `Save changes this ${statusText} article?`;
        desc = 'Do you want to save the changes you made to this academy?';
      }

      break;
    case 7:
      title = 'Unhide this article?';
      desc = `This will show the article on the ${$ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ'} immediately.`;
      break;
    default:
      title = '';
      desc = '';
  }
  return { title, desc };
});

//++++++++++++++++++++++++++++++++++++
// Methods
//++++++++++++++++++++++++++++++++++++
const openDesignDialog = () => {
  // snapshot saved header so we can restore if dialog closed without publish
  prevHeaderSaved.value = { ...headerSaved.value };
  designDialogVisible.value = true;
};

// Dialog event handlers
const onDesignPublish = (publishedForm) => {
  const fromData = new FormData();
  loading.value = true;

  if (publishedForm.backgroundType == 'color') {
    fromData.append('remove_background_image', 1);
    fromData.append('background_color_hex', publishedForm.color);
  } else if (publishedForm.backgroundType === 'image' && publishedForm.image) {
    fromData.append('background_image_file', publishedForm.image);
  }

  fromData.append('title_color_hex', publishedForm.textColor);
  fromData.append('sub_color_hex', publishedForm.subtextColor);
  fromData.append('title', publishedForm.title);
  fromData.append('sub_text', publishedForm.subtext);

  ajax
    .post('/creator-academy/save-metadata', fromData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    .then((res) => {
      openNotBottom('Header design published.', 'success');
      headerSaved.value = publishedForm;
      // 保存到 designForm
      designForm.value = publishedForm;
      loading.value = false;
    })
    .catch((err) => {
      openNotBottom('Header design save failed.', 'error');
      loading.value = false;
    });

  prevHeaderSaved.value = null;
};

const formatDate = (dateStr, format = 'MMM DD, YYYY hh:mm A') => {
  if (!dateStr) return null;
  return moment(dateStr).format(format);
};

const sortFun = (key) => {
  if (key === sort.value.sort_key) {
    sort.value.sort_val = sort.value.sort_val === 'asc' ? 'desc' : 'asc';
  } else {
    sort.value.sort_key = key;
    sort.value.sort_val = 'asc';
  }
  getAcadmyList();
};

const previewAcademy = () => {
  goPreview();
};

const openConfirmDialog = (type, data, needSave) => {
  if (type === DOTHING_CODE.Publish && !data.cover_image_url && !data.img?.src) {
    noCoverPublishDialogVisible.value = true;
    return;
  }
  if (needSave) data.needSave = needSave;
  handle_doThing_data.value = data;
  handle_doThing_type.value = type;
  handleAllModel.value = true;
};

const onPageChange = () => {
  sort.value.sort_key = '';
  getAcadmyList();
};

const getAcadmyList = () => {
  loading_table.value = true;
  const params = [];
  if (sort.value.sort_key) {
    params.push(`sort_key=${sort.value.sort_key}`);
    params.push(`sort_val=${sort.value.sort_val}`);
  }
  if (selectedPage.value && selectedPage.value !== '0') params.push(`creator_academy_page_ids[]=${selectedPage.value}`);
  const url = params.length ? `/creator-academy/list-article?${params.join('&')}` : '/creator-academy/list-article';
  ajax
    .get(url)
    .then((res) => {
      academies.value = handListData(res.data.data, pageList.value);
      loading_table.value = false;
    })
    .catch((err) => {
      console.log('err', err);
      loading_table.value = false;
    });
};

// ─── Drag-to-reorder ─────────────────────────────────────────────────────────

const onReorder = (event) => {
  // capture the moved item before applying (event.from = original index)
  const movedItem = academies.value[event.from];

  event.apply(academies.value);

  // event.to = new index (0-based), convert to 1-based position
  const newPosition = event.to + 1;

  // build the ordered payload: [{ id, order }]
  const orderedPayload = academies.value.map((item, idx) => ({
    id: item.id,
    order: idx + 1,
  }));

  updateOrderApi(orderedPayload, { id: movedItem.id, newPosition });
};

const updateOrderApi = (orderedItems, moved) => {
  console.log('[Reorder] moved item id:', moved.id, '→ new position:', moved.newPosition);
  //console.log('[Reorder] full order:', orderedItems);

  return ajax.post('/creator-academy/sort-article', { creator_academy_article_id: moved.id, new_sort_order: moved.newPosition })
  .then(e=>{
    openNotBottom('Articles reordered', 'success');
  }).catch(err=>{
    console.log('err', err);
    openNotBottom('Failed to reorder articles', 'error');
  });

};

const getPageList = () => {
  ajax
    .get('/creator-academy/list-page')
    .then((res) => {
      pageList.value = res.data.data;
    })
    .catch((err) => {
      console.log('err', err);
    });
};
//--------------------
// Alert Dialog State
//--------------------
const handleAlertConfirm = () => {
  if ([1, 2, 3, 4, 5, 6, 7].includes(handle_doThing_type.value)) {
    switch (handle_doThing_type.value) {
      case 1:
        // Publish
        callPublish();
        break;
      case 2:
        // Delete Draft
        callDelete();
        break;
      case 3:
        // Hide
        callHide(true);
        break;
      case 4:
        // Delete Published
        callDelete();
        break;
      case 5:
        // Exit with save
        acadmyEdit.value.save();
        break;
      case 6:
        // Save
        acadmyEdit.value.save();
        break;
      case 7:
        // Unhide
        callHide(false);
        break;
      default:
        break;
    }
  } else {
    // For table operations
    if (alertCallback.value) {
      alertCallback.value(handle_doThing_type.value);
    }
  }
  handleAllModel.value = false;
};

const closeHandleModel = () => {
  if (handle_doThing_type.value === 5) {
    acadmyEdit.value.closeDrawer();
  }
  handleAllModel.value = false;
};

const callPublish = (formEditVal) => {
  loading.value = true;

  let api = '/creator-academy/publish-draft-article';
  if ((!handle_doThing_data.value.id || handle_doThing_data.value.needSave) && !formEditVal) {
    acadmyEdit.value.save('needPublish');
    return;
  } else if (formEditVal) {
    handle_doThing_data.value = formEditVal;
  }

  ajax
    .post(api, { creator_academy_article_id: handle_doThing_data.value.id })
    .then((res) => {
      openNotBottom(`Article published`, 'success');
      acadmyEdit.value.closeDrawer();
      getAcadmyList();
      loading.value = false;
    })
    .catch((err) => {
      console.log('err', err);
      let err_text= 'Article publish failed.';
      if (err && err.response && err.response.data.data) {
         err_text = err.response.data.data.message;
      }
      openNotBottom(err_text, 'error');
      loading.value = false;
    });
};

const callDelete = () => {
  loading.value = true;

  ajax
    .post('/creator-academy/delete-article', { creator_academy_article_id: handle_doThing_data.value.id })
    .then((res) => {
      if (handle_doThing_data.value.status === STATUS_CODE.Draft) {
        openNotBottom(`Draft deleted`, 'success');
      } else {
        openNotBottom(`Article deleted`, 'success');
      }
      acadmyEdit.value.closeDrawer();
      getAcadmyList();
      loading.value = false;
    })
    .catch((err) => {
      console.log('err', err);
      openNotBottom(`Article delete failed.`, 'error');
      loading.value = false;
    });
};

const callHide = (hide) => {
  loading.value = true;

  let api = hide ? '/creator-academy/hide-article' : '/creator-academy/publish-draft-article';

  ajax
    .post(api, { creator_academy_article_id: handle_doThing_data.value.id })
    .then((res) => {
      if (hide) {
        openNotBottom(`Article hidden in the Creator Academy`, 'success');
      } else {
        openNotBottom(`Article is now visible in the Creator Academy`, 'success');
      }
      getAcadmyList();
      loading.value = false;
    })
    .catch((err) => {
      console.log('err', err);
      openNotBottom(`${hide ? 'Hide' : 'Unhide'} failed.`, 'error');
      loading.value = false;
    });
};

//+++++++++++++++++++++
//mounted
//+++++++++++++++++++++
onMounted(async () => {
  try {
    all_Loading.value = true;

    const metadataRes = await ajax.get('/creator-academy/get-metadata');
    const data = metadataRes.data.data;
    headerSaved.value.backgroundType = data.background_image_url ? 'image' : 'color';
    headerSaved.value.color = data.background_color_hex || '#F1F4F9';
    headerSaved.value.textColor = data.title_color_hex || '#000000';
    headerSaved.value.subtextColor = data.sub_color_hex || '#000000';
    headerSaved.value.imageUrl = data.background_image_url || '';
    headerSaved.value.title = data.title || ($ProjectName === 'cj' ? 'Creator Academy' : 'Creator HQ');
    headerSaved.value.subtext = data.sub_text || ($ProjectName === 'cj' ? 'Manage your Creator Academy content here.' : 'Manage your Creator HQ content here.');
    designForm.value = headerSaved.value;

    const pageRes = await ajax.get('creator-academy/list-page');
    pageList.value = pageRes.data.data;

    const articleRes = await ajax.get('/creator-academy/list-article');
    academies.value = handListData(articleRes.data.data, pageList.value);
  } catch (err) {
    console.log(err);
  } finally {
    all_Loading.value = false;
  }

  emitter.on('confirm-dialog', (payload) => {
    openConfirmDialog(payload.type, payload.data, payload.needSave);
  });
  emitter.on('refresh-academy-list', getAcadmyList);
  emitter.on('refresh-academy-page-list', getPageList);
});

onUnmounted(() => {
  emitter.off('confirm-dialog');
  emitter.off('refresh-academy-list', getAcadmyList);
  emitter.off('refresh-academy-page-list', getPageList);
});
</script>

<style lang="scss">
.acadmy-content {
  height: calc(100vh - 16px);
  padding: 24px 48px;
  display: grid;
  grid-template-rows: auto auto 1fr;
  grid-template-columns: 100%;
  overflow: hidden;

  .academy-table-scroll {
    height: 94%;
  }

  .academy-table,
  .page-header-acdemy,
  .table-top-header {
    .el-button {
      margin: 0;
      span {
        gap: 6px;
      }
      svg {
        width: 12px;
        height: 12px;
      }
    }
  }

  .page-header-acdemy {
    height: 56px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    h3 {
      font: var(--font-demi-24);
    }

    .right-btn-block {
      display: flex;
      align-items: center;
      gap: 12px;

      .page-filter-select {
        width: 160px;
      }
    }
  }

  .table-top-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: var(--light-neutral);
    padding: 48px 24px;
    aspect-ratio: 4 / 3;
    background-size: cover;
    background-position: center;
    min-height: 160px;
    max-height: 186px;
    width: 100%;

    .left-header {
      h1 {
        font: var(--font-demi-30);
      }
      .subtitle {
        font: var(--font-med-24);
      }
    }
  }

  .academy-table {
    margin: 0;

    thead {
      top: 0;
      position: sticky;
    }

    td,
    th {
      padding: 12px;
      vertical-align: middle;
      font: var(--font-med-12);

      &.col-drag {
        width: 48px;
        padding: 0 4px;
        text-align: center;

        .drag-handle {
          cursor: grab;
          transition: transform .2s ease;
          font-size: 16px;
          user-select: none;
          display: block;
          line-height: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          svg{
            fill:var(--black-75);
          }
          

          &:active { cursor: grabbing; }
          &:hover { color: var(--black-60); }
        }
      }

      .pub-btn {
        color: var(--blue);
        cursor: pointer;
      }

      &.col-article {
        width: 240px;
      }

      &.col-status {
        width: 120px;

        .text-50 {
          color: var(--black-50);
        }
      }

      &.col-last-update {
        width: 200px;
      }

      &.col-date-created {
        width: 200px;
      }

      &.col-page {
        width: 180px;
        min-width: 186px;
      }

      &.col-actions {
        width: 140px;
      }
    }

    th.col-article {
      span {
        font: var(--font-med-12);
      }
    }

    td.col-article {
      .article-cell {
        display: flex;
        align-items: flex-start;
        gap: 12px;
        width: 100%;
        min-height: 60px;

        .article-img {
          width: 60px;
          height: 60px;
          border-radius: 4px;
          object-fit: cover;
          flex-shrink: 0;
        }

        .article-img-empty {
          width: 60px;
          height: 60px;
          border-radius: 4px;
          background-color: var(--black-10);
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
          color: var(--black-50);
          flex-shrink: 0;
        }

        .article-title {
          flex: 1;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
          font: var(--font-med-14);
        }
      }
    }

    td.col-status span {
      font: var(--font-med-12);
    }

    td.col-last-update span,
    td.col-date-created span {
      font: var(--font-med-12);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      display: block;
    }

    /* ensure date and time each render on their own line */
    td.col-last-update .date-line,
    td.col-last-update .time-line,
    td.col-date-created .date-line,
    td.col-date-created .time-line {
      display: block;
    }

    td.col-page {
      min-height: 40px;
    }

    td.col-actions {
      .actions-cell {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 12px;

        .action-icon {
          width: 16px;
          height: 16px;
          cursor: pointer;
          transition: color 0.2s ease;

          &.action-delete {
            color: var(--red);
          }
        }
      }
    }

    .no-data {
      padding: 120px 20px;
      text-align: center;
      color: var(--text-primary);
      font: var(--font-med-20);

      p {
        margin-bottom: 24px;
      }
    }

    .drag-feedback-row td {
      background: var(--PB-10, #e8f0fc);
      border-bottom: 2px solid var(--PB-100, #0066cc);
      height: 4px;
      padding: 0;
    }

    tr.drag-mode-reordering {
      opacity: 0.5;
    }
  }
}

.alert-handle-dialog {
  header {
    display: none;
  }

  h3 {
    font: var(--font-med-20);
    color: var(--text-primary);
    margin-bottom: 12px;
  }

  div {
    font-size: 16px;
  }

  .btn-box {
    margin-top: 24px;
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .el-button {
      margin: 0;
    }
  }
}
</style>

<style>
.no-cover-dialog {
  .no-cover-title {
    font-size: 18px;
    font-weight: 600;
  }

  .no-cover-body {
    font-size: 14px;
    color: #555;
    line-height: 1.6;
  }

  .el-dialog__footer {
    display: flex;
    justify-content: flex-end;
  }
}
</style>
